module.exports = __webpack_public_path__ + "static/media/csr_feedingamerica.af8b0afa.jpg";